import React from "react";

import { formatDurationNs } from "./formatDurationNs";

/**
 * Renders a signed nanosecond duration as readable text (`923.000 ms`, in the
 * unit {@link formatDurationNs} picks), with the raw ns in `title` so hovering
 * recovers the exact value. AI tools emit durations as integer ns, and two
 * places show them:
 * - A model-written `d=<n>ns` in a response, which remarkTimestampMentions
 *   rewrites to an `ai-dur:<ns>` link, or `ai-dur-hl:<ns>` when it fills an
 *   inline code span (`highlighted`, rendered as `<code>`).
 * - Nanosecond durations in AnalyzeTopicOutput (`*_ns` columns, bucket width,
 *   time spanned by omitted rows).
 *
 * Unlike the shared `Timestamp`, it shows no hover actions: a duration names
 * no instant to jump to or set as t=0.
 */
export const InlineDuration: React.FC<{
  ns: bigint;
  highlighted?: boolean;
}> = ({ ns, highlighted = false }) => {
  const Tag = highlighted ? "code" : "span";
  const rawNs = ns.toString();
  return (
    <Tag data-roboto-inline-duration={rawNs} title={`${rawNs} ns`}>
      {formatDurationNs(ns)}
    </Tag>
  );
};
